import {
  CLEAR_FIELD_ACTION,
  FOCUS_FIELD_ACTION,
  REVALIDATE_FIELD,
  SET_PLACEHOLDERS_ACTION,
  STYLE_FIELD_ACTION,
} from "../constants";

export const toStyleProperty = (prop: string) =>
  prop.replaceAll(/([A-Z])/g, "-$1").toLowerCase();

export const urlRegEx = /url[\s\S]*/gim;

export const applyStyleHandler = (
  event: MessageEvent<{ type: string; data: CSSStyleDeclaration }>
) => {
  const fieldElement = document.querySelector("input");

  const {
    source,
    data: { type, data },
  } = event;

  if (source !== parent || !fieldElement) {
    return;
  }

  if (type !== STYLE_FIELD_ACTION) {
    return;
  }

  Object.entries(data).forEach(([prop, value]) => {
    if (value.search(urlRegEx) !== -1) {
      return;
    }

    fieldElement.style.setProperty(toStyleProperty(prop), value);
  });
};

export const focusHandler = (event: MessageEvent<{ type: string }>) => {
  const fieldElement = document.querySelector("input");

  const {
    source,
    data: { type },
  } = event;

  if (source !== parent || !fieldElement) {
    return;
  }

  if (type !== FOCUS_FIELD_ACTION) {
    return;
  }

  fieldElement.focus();
};
export const clearFieldHandler = (event: MessageEvent<{ type: string }>) => {
  const fieldElement = document.querySelector("input");

  const {
    source,
    data: { type },
  } = event;

  if (source !== parent || !fieldElement) {
    return;
  }

  if (type !== CLEAR_FIELD_ACTION) {
    return;
  }

  fieldElement.value = "";
};

export const setPlaceholderHandler = (
  event: MessageEvent<{ type: string; payload: string }>
) => {
  const fieldElement = document.querySelector("input");

  const {
    source,
    data: { type, payload },
  } = event;

  if (source !== parent || !fieldElement) {
    return;
  }

  if (type !== SET_PLACEHOLDERS_ACTION) {
    return;
  }

  fieldElement.setAttribute("placeholder", payload);
};

export const revalidateHandler = (
  event: MessageEvent<{ type: string; payload: string }>
) => {
  const fieldElement = document.querySelector("input");

  const {
    source,
    data: { type },
  } = event;

  if (source !== parent || !fieldElement) {
    return;
  }

  if (type !== REVALIDATE_FIELD) {
    return;
  }

  fieldElement.dispatchEvent(new Event("change"));
  fieldElement.dispatchEvent(new Event("input"));
};
